@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.column {
    flex-grow: 1;

    & .columnStateCheckbox {
        display: none;
    }

    & .columnTitle {
        display: block;
        text-transform: uppercase;
        color: var(--color-mid-gray);
        margin-bottom: 0;
        padding: 1.25rem 1rem 0 1.25rem;
        font-weight: 700;
        font-size: 1rem;

        @include breakpoint.breakpoint(layout.$belowMedium) {
            padding: 1.25rem;
            border-top: 1px solid var(--color-silver);
        }
    }

    &.collapsable {
        .columnTitle {
            @include breakpoint.breakpoint(layout.$belowMedium) {
                color: var(--color-black);
                cursor: pointer;
                font-size: 1rem;
                padding: 1rem;
                position: relative;
                text-align: left;
                width: 100%;

                &:focus {
                    background-color: #e6e6e6;
                    outline: 2px solid var(--color-black);
                }

                &::after {
                    background-color: var(--color-lobster);
                    content: "";
                    display: block;
                    height: 25px;
                    margin-right: 0.25rem;
                    mask-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.375 8.6875C17.375 7.8137 16.6238 7.0625 15.75 7.0625H11.1875V2.5C11.1875 1.6262 10.4363 0.875 9.5625 0.875H8.4375C7.51846 0.875 6.8125 1.63639 6.8125 2.5V7.0625H2.25C1.33096 7.0625 0.625 7.82389 0.625 8.6875V9.8125C0.625 10.7215 1.34105 11.4375 2.25 11.4375H6.8125V16C6.8125 16.909 7.52854 17.625 8.4375 17.625H9.5625C10.4261 17.625 11.1875 16.919 11.1875 16V11.4375H15.75C16.6136 11.4375 17.375 10.7315 17.375 9.8125V8.6875Z' fill='black'/%3E%3C/svg%3E");
                    mask-position: center;
                    mask-repeat: no-repeat;
                    mask-size: 20px 20px;
                    min-width: 25px;
                    position: absolute;
                    right: 16px;
                    top: 18px;
                }
            }
        }

        .columnContent {
            @include breakpoint.breakpoint(layout.$belowMedium) {
                display: none;
            }
        }

        .columnStateCheckbox:checked {
            & + .columnTitle {
                @include breakpoint.breakpoint(layout.$belowMedium) {
                    border-bottom: 1px solid var(--color-silver);

                    &::after {
                        mask-image: url("data:image/svg+xml,%3Csvg width='18' height='5' viewBox='0 0 18 5' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.375 1.6875C17.375 0.813701 16.6238 0.0625 15.75 0.0625H2.25C1.33096 0.0625 0.625 0.823893 0.625 1.6875V2.8125C0.625 3.72145 1.34105 4.4375 2.25 4.4375H15.75C16.6136 4.4375 17.375 3.73154 17.375 2.8125V1.6875Z' fill='black'/%3E%3C/svg%3E%0A");
                    }
                }
            }

            & + .columnTitle + .columnContent {
                @include breakpoint.breakpoint(layout.$belowMedium) {
                    display: block;
                }
            }
        }
    }

    &.noncollapsable {
        @include breakpoint.breakpoint(layout.$belowMedium) {
            text-align: center;
        }
    }
}
